export const currencyFormat = (number: number) =>
  number.toLocaleString('fr-FR', { currency: 'EUR', style: 'currency' });

const NumberUtils = {
  currencyFormat
};

export default NumberUtils;
